import React from 'react';
import './Loader.css';

export function Loader() {
  return (
    <div className="w-full h-full flex justify-center items-center">
      <div className="loader"></div>
    </div>
  );
}

export default Loader;
